import { serverFetchPCByIds } from "@/app/serverFunctionsCentra";
import type { ProductCard } from "@/lib/centra/formatters/formatProductCards/formatProductCard";
import type { ProductListingStoryblok } from "@/types/storyblok-blok-types";

import ProductListingUI from "./ProductListingUI";

export const formatProductListing = async (
  blok: ProductListingStoryblok,
): Promise<{ card: ProductCard; tag: string }[]> => {
  const { products: productIds } = blok;
  const productCards = await serverFetchPCByIds(
    productIds.map((id) => `${id}`),
  );

  if (!productCards) return [];
  return productCards.map((card) => ({
    card,
    tag: "new",
  }));
};
export type ProductListingType = Awaited<
  ReturnType<typeof formatProductListing>
>;

const ServerProductListing = async ({
  blok,
}: {
  blok: ProductListingStoryblok;
}) => {
  const productCards = await formatProductListing(blok);

  return <ProductListingUI blok={blok} productCards={productCards} />;
};

export default ServerProductListing;
